export default __webpack_public_path__ + "static/media/iconAddressHome.7464cb06.svg";